import { lineItemStatuses } from '@/parcels/constants'

export const getAmendItemsPayload = items => {
  const itemIds = items
    .filter(item => item.newStatus === lineItemStatuses.packed && item.status !== lineItemStatuses.packed)
    .map(item => item.id)

  return {
    item_ids: itemIds,
  }
}
